/** The three screen shapes every layout rule is written for. */
export type ScreenShape = "desktop" | "mobile" | "mobile_landscape";

/** What the launch context says about the device, when it says anything: it wins over the width breakpoint. */
export type ScreenShapeHint = "desktop" | "mobile" | null;

/** The CSS-pixel width at which a boot WITHOUT a device hint is the desktop shape. */
export const DESKTOP_BREAKPOINT_WIDTH = 1400;

/**
 * Whether a viewport is portrait for its background: at least as tall as wide, as CSS's `(orientation: portrait)` has it
 * (decision 69). A background still is chosen by this everywhere — the boot loader by the media query, the intro splash
 * and the scene by this — so all three agree; the shape stays for layouts (a tall desktop window is still `desktop`).
 */
export function isPortrait(size: { readonly width: number; readonly height: number }): boolean {
  return size.height >= size.width;
}

/** `mobile_landscape` only when the hint drove the mobile shape (a wide desktop window without a device stays `desktop` by width). */
export function resolveScreenShape(input: { width: number; height: number; hint: ScreenShapeHint; desktopBreakpointWidth?: number }): ScreenShape {
  if (input.hint === "desktop") return "desktop";
  if (input.hint === "mobile") return input.width > input.height ? "mobile_landscape" : "mobile";
  return input.width >= (input.desktopBreakpointWidth ?? DESKTOP_BREAKPOINT_WIDTH) ? "desktop" : "mobile";
}
